<template>
  <th class="th-sorter" :class="[sortProp, {'active': activeSortKey === sortProp}]" @click="sortBy">
    <div class="column-width">{{title}}
    <span class="icon-menu-open"></span>
    </div>
  </th>
</template>

<script>
  export default {
    props: {
      activeSortKey: {
        type: String
      },
      sortProp: {
        type: String
      },
      title: {
        type: String
      }
    },
    methods: {
      sortBy () {
        this.$emit('sortby', this.sortProp)
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .th-sorter {
    transition: transform 0.25s;
    cursor: pointer;
    user-select: none;
    color: #3d4340;
    font-weight: bold;
    position: sticky;
    z-index: 3;
    top: 31px !important;
  }

  .th-sorter.active {
    color: var(--blue);
  }
  .th-sorter > span{
    opacity: 0.3;
  }

  .th-sorter:active {
    transform: scale(0.95);
  }

  .th-sorter.active > span{
    opacity: 1;
  }

  .column-width {
    min-width: 90px;
    max-width: 100px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .th-sorter.name .column-width {
    min-width: 200px;
    max-width: 200px;
  }

  .th-sorter.name {
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    z-index: 3;
    top: 0 !important;
    left: 0;
    border-collapse: collapse;
    background: #ffffff;
  }

</style>



// WEBPACK FOOTER //
// AssignHoursAllUsersTheadTh.vue?3940021d